import React, { Component } from 'react';
import PropTypes from 'prop-types';
import keydown from 'react-keydown';
import onClickOutside from 'react-onclickoutside';
import classnames from 'classnames';

import COLORS from 'constants/colorOptions';
import Color from './components/Color';

import './style.scss';

export class FormColorPalette extends Component {
  static propTypes = {
    isDisabled: PropTypes.bool,
    isOpen: PropTypes.bool,
    input: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string,
      onChange: PropTypes.func,
    }).isRequired,
  };

  static defaultProps = {
    isDisabled: false,
    isOpen: false,
  };

  state = {
    isOpen: this.props.isOpen,
  };

  toggle = () => {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }));
  };

  handleClose = () => {
    this.setState({
      isOpen: false,
    });
  };

  handleClickOutside = () => {
    if (this.state.isOpen) {
      this.handleClose();
    }
  };

  handleSelect = ({
    target: {
      dataset: { color },
    },
  }) => {
    this.props.input.onChange(color);
    this.handleClose();
  };

  render() {
    const { isDisabled, input } = this.props;
    const { isOpen } = this.state;
    const color = input.value;

    /* eslint-disable jsx-a11y/click-events-have-key-events */
    /* eslint-disable jsx-a11y/no-static-element-interactions */
    return (
      <div
        styleName={classnames('color-palette', {
          'is-disabled': isDisabled,
        })}
        data-test="color-palette"
      >
        <div styleName="color-picker" data-test="color-picker">
          <span
            data-color={color}
            styleName="color"
            style={{ backgroundColor: color }}
            onClick={this.toggle}
          />
        </div>
        {isOpen && (
          <ul styleName="colors">
            {COLORS.map(_color => (
              <Color
                key={_color}
                isSelected={_color === color}
                color={_color}
                onSelect={this.handleSelect}
              />
            ))}
          </ul>
        )}
      </div>
    );
  }
}

export default keydown(onClickOutside(FormColorPalette));
